var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2622_10477)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_10477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.15 34.0332C49.3607 33.522 48.4404 33.25 47.5 33.25C46.5596 33.25 45.6393 33.522 44.85 34.0332L32.5 41.9994L37.5 45.2244V57.5169L37.8663 57.8832C37.9838 57.9994 40.8088 60.7494 47.5 60.7494C54.1912 60.7494 57.0163 57.9994 57.1338 57.8832L57.5 57.5169V45.2244L60 43.6119V56.9994H62.5V41.9994L50.15 34.0332ZM55 56.3944C52.741 57.7471 50.1291 58.3932 47.5 58.2494C44.8711 58.3934 42.2591 57.7479 40 56.3957V46.8369L44.85 49.9619C45.6389 50.4743 46.5593 50.747 47.5 50.747C48.4407 50.747 49.3611 50.4743 50.15 49.9619L55 46.8369V56.3944ZM48.795 47.8644C48.4096 48.1151 47.9597 48.2485 47.5 48.2485C47.0403 48.2485 46.5904 48.1151 46.205 47.8644L37.1125 41.9994L46.205 36.1344C46.5904 35.8837 47.0403 35.7503 47.5 35.7503C47.9597 35.7503 48.4096 35.8837 48.795 36.1344L57.8875 41.9994L48.795 47.8644Z",
    fill: "#20435D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2622_10477",
    x: 0.5,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2622_10477"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_10477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(32.5 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/expertise.a1243ad6c480620d072930166323572e.svg";
export { ForwardRef as ReactComponent };